import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { Core } from "../helpers/core";
import { Money } from "../helpers/money";
import { AppIcons } from "../constants/app-icons";
import { DOMAIN } from "./domain-constant";

export default class DepositService extends ApiService {
  namespace = "record-deposit";
  template = "defaultTemplate";
  listingRelations = "accountName,items,items.deposited";
  relations =
    "?expand=payments,payments.paymentMethod,payments.customer,accountName,lessAccountName,less_account";
  fullWindow = false;
  icon = "SafetyBox";
  DOMAIN = DOMAIN.DEPOSIT;
  data = [];
  favicon = "database";
  showLeftBar = false;
  useNextNumber = true;
  enableSchedular = true;
  name = this.terminology.deposit.plural;
  singular = this.terminology.deposit.singular;
  plural = this.terminology.deposit.plural;
  vowel = this.terminology.deposit.vowel;
  labelKey = "number";
  layout = 2;
  Width = 1500;
  gemItems = [
    {
      key: "listing",
      label: "All Deposits",
      icon: AppIcons.BULLETS,
      services: DOMAIN.DEPOSIT,
    },
    {
      key: "create",
      label: "Record a Deposit",
      icon: AppIcons.PLUS,
    },
  ];
  columns = [
    {
      header: this.t("number"),
      icon: AppIcons.SHRED,
      field: "number",
      sortable: true,
      template: (data) => data.number ?? "",
    },
    {
      header: this.t("methods"),
      icon: AppIcons.BOX_WITH_STAR,
      field: "method",
      sortable: true,
      template: (data) => data.accountName?.display_name ?? "",
    },
    {
      header: this.t("itemsDeposited"),
      icon: AppIcons.NUMBER,
      field: "deposited",
      sortable: true,
      template: (data) => {
        const count =
          data.items != null && data.items !== ""
            ? Number(data.items)
            : (data.payments || []).length;
        return Number.isNaN(count) ? "0" : String(count);
      },
    },
    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      sortable: true,
      template: (data) => Core.datey(data.date) || "",
    },
    {
      header: this.t("amount"),
      icon: AppIcons.MONEY,
      field: "amount",
      sortable: true,
      template: (data) => Money.format(data.amount),
    },
  ];
  lineItems = [
    {
      key: "edit",
      label: "Apply Subtotal",
      icon: PrimeIcons.PENCIL,
    },
    {
      key: "announce",
      label: "Bank Line",

      icon: PrimeIcons.LIST,
    },
    {
      key: "email",
      label: "Discount",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "bookmark",
      label: "Good",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Inventory Item",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Other Change",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Over Payment",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Service",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Tax",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      separator: true,
    },
    {
      key: "inactive",
      label: "Time & Expenses",
      icon: PrimeIcons.LOCK,
    },
  ];
  moreItems = [
    {
      key: "create",
      label: "Load template",
      // icon: PrimeIcons.FOLDER,
      icon: "Folder",
      type: "1",
    },
    {
      key: "create",
      label: "Save and preview",
      // icon: PrimeIcons.FILE,
      icon: "Preview",
      type: "2",
    },
    {
      key: "create",
      label: "Save and print",
      // icon: PrimeIcons.PRINT,
      icon: "Printer",
      type: "3",
    },
    {
      key: "create",
      label: "Save and e-mail",
      // icon: PrimeIcons.ENVELOPE,
      icon: "Mail",
      type: "4",
    },
    {
      key: "create",
      label: "Manage layout",
      // icon: PrimeIcons.LIST,
      icon: "Layout",
      type: "5",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: this.t("editThisEntity", { entity: this.singular }),
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: this.t("announceThisEntity", { entity: this.singular }),
      services: -3,
      icon: AppIcons.ANNOUNCEMENT,
    },
    {
      key: "email",
      label: this.t("emailThisEntity", { entity: this.singular }),
      services: 208,
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: this.t("bookmarkThisEntity", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "viewJournal",
      label: this.t("viewJournal"),
      icon: AppIcons.JOURNAL_VIEW,
    },
  ];
  getActionMenu(item) {
    return this.listMenuItems;
  }
  permissions = [
    {
      key: "is_in_print_que",
      display_name: "Print Que",
      icon: AppIcons.FAX,
      value: 1,
    },
    {
      key: "is_in_email_que",
      display_name: "Email Que",
      icon: AppIcons.MAIL,
      value: 1,
    },
  ];
  filterItems = [
    { name: "Status", key: "status", value: "2", realm: "2" },
    { name: "Date", key: "date", value: "3", realm: "1" },
    { name: "Due Date", key: "due", value: "4", realm: "0" },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Record a Deposit",
      icon: AppIcons.LIST,
    },
  ];

  // loadJournal(id) {
  //   let moduleNode = "/" + id;
  //   moduleNode += "?expand=journals,journals.accounts,journals.entityLabel";
  //   return this.get({}, `${moduleNode}`).then((res) => res);
  // }

  constructor() {
    super("bank-deposits");
  }
}
